import React from 'react';
import { Outlet } from 'react-router-dom';
import ChatsSidebar from '../Components/Chat/ChatsSidebar';
import { ThreadApiProvider } from '../Services/ThreadApiProvider';
import { ChannelApiProvider } from '../Services/ChannelApiProvider';
import './Chats.css';

const Chats = ({ canEdit }) => {
  return (
    <ThreadApiProvider>
      <ChannelApiProvider>
        <div className="main-chat d-flex flex-row">
          <ChatsSidebar />
          <Outlet context={{ canEdit }} />
        </div>
      </ChannelApiProvider>
    </ThreadApiProvider>
  );
};

export default Chats;
